import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ComplaintButtonNew } from '../../components/ComplaintButtonNew';
import { ComplaintContainer } from '../../components/complaint/container';
import { trackClick } from '../../components/main/complaint_button/tracking';
import { offerSelector } from '../../selectors';
import { selectAgent } from '../../selectors/selectAgent';
import { EFeedbackComplaint, statusChanger } from '../../store/complaint/feedback_complaint';
import { resetPrefilledEmail } from '../../store/complaint/prefilledEmail';
import { getCustomUrl } from '../../utils/tracking/getCustomUrl';

export function ComplaintButtonNewContainer() {
  const dispatch = useDispatch();
  const offer = useSelector(offerSelector);
  const agent = useSelector(selectAgent);

  const [isComplaintPopupOpen, setIsComplaintPopupOpen] = React.useState(false);

  const handleButtonClick = React.useCallback(() => {
    trackClick(getCustomUrl(offer, agent));
    setIsComplaintPopupOpen(!isComplaintPopupOpen);
  }, [offer, agent, isComplaintPopupOpen]);

  const handleOutsideClick = React.useCallback(() => {
    setIsComplaintPopupOpen(false);
    statusChanger(EFeedbackComplaint.default);
    dispatch(resetPrefilledEmail());
  }, []);

  return (
    <ComplaintButtonNew
      onButtonClick={handleButtonClick}
      tooltipOpened={isComplaintPopupOpen}
      onTooltipClose={handleOutsideClick}
      tooltip={<ComplaintContainer handleOutsideClick={handleOutsideClick} />}
    />
  );
}
